import { YesNoAnswer } from "../../../incidentLog/IncidentLogDialog.types.ts";

// The template editor preview shows every field so the whole template can be reviewed, even the representative's name
// that stays hidden until the request is known to be made through a representative.
export function showsRepresentativeName(answer: YesNoAnswer | null | undefined, isPreview: boolean) {
    return isPreview || answer === YesNoAnswer.Yes;
}
